
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snohistorikk",
      function () {
        return require("private-next-pages/[region]/[resort]/snohistorikk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snohistorikk"])
      });
    }
  